import { DatePicker, Input, message, Select, Spin, TimePicker } from "antd";
import React, { useEffect, useState } from "react";
import { IoLocationSharp } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import doctorIcon from "../../assets/images/Svg/doctorIcon.svg";
import PatientService from "../../Services/PatientService";
import { bookFreeAppointment } from "../../Redux/actions/appointmentActions";
import enrollmentServices from "../../Services/enrollmentServices";
import { set } from "lodash";
import dayjs from "dayjs";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import AppointmentService from "../../Services/AppointmentService";

const RequestApptDrawer = ({ selectedDoctor, closeDrawer }) => {
  console.log("Selected Doctor:", selectedDoctor);
  const { patientData } = useSelector((state) => state.auth);
  const [selectedPatient, setSelectedPatient] = useState(patientData);
  const [famList, setFamList] = useState([]);
  const [consultationType, setConsultationType] = useState("video");
  const [consultationDate, setConsultationDate] = useState(null);
  const [consultationReasonList, setConsultationReasonList] = useState([]);
  const [consReason, setConsReason] = useState("");
  const [slotsLoader, setSlotsLoader] = useState(false);
  const [selectedDoctorSlots, setSelectedDoctorSlots] = useState([]);
  useEffect(() => {
    if (patientData && patientData?.patientId) {
      getFamilyList();
      setSelectedPatient(patientData);
    }
  }, [patientData]);

  useEffect(() => {
    fetchSlots(selectedDoctor.userId);
  }, []);

  const fetchSlots = async (doctorId) => {
    const payload = {
      userId: doctorId,
      status: 1,
    };
    setSlotsLoader(true);

    try {
      const response = await AppointmentService.UserSavedTemplates(payload);
      console.log("Doctor Slots Response:", response);
      if (response.data && response.data.length !== 0) {
        setSelectedDoctorSlots(response.data);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSlotsLoader(false);
    }
  };

  const getFamilyList = async () => {
    if (patientData.parentPatientId) return;
    const payload = {
      parentPatientId: patientData?.patientId,
    };

    try {
      const response = await PatientService.getPatient(payload);
      setFamList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handlePatientChange = (value) => {
    if (value === patientData?.patientId) {
      setSelectedPatient(patientData);
    } else {
      const selectedPatObj = famList.find((pat) => pat.patientId === value);
      setSelectedPatient(selectedPatObj);
    }
  };

  const handleChange = (event) => {
    setConsultationType(event.target.value);
  };

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const handleApptSubmit = () => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }
    if (!consultationDate || !timeSlot || !consReason) {
      message.error("Please fill all required fields");
      return;
    }
    let appointmentPayload = {
      account_Id: "DZA1891063",
      clinic_Id: selectedDoctor?.clinic_Id,
      consultationDate: consultationDate,
      consultationReason: consReason,
      consultationType: consultationType,
      createdBy: selectedDoctor?.userId,
      endTime: dayjs(timeSlot, "HH:mm").add(15, "minute").format("hh:mm A"),
      modifiedBy: selectedDoctor?.userId,
      patientId: selectedPatient?.patientId,
      patientName: selectedPatient?.firstName + " " + selectedPatient?.lastName,
      startTime: dayjs(timeSlot, "HH:mm").format("hh:mm A"),
      status: 1,
      userId: selectedDoctor?.userId,
      userName: selectedDoctor?.firstName + " " + selectedDoctor?.lastName,
    };

    setLoading(true);
    enrollmentServices
      .RequestInvite(appointmentPayload)
      .then((result) => {
        if (result?.data?.data == 1) {
          closeDrawer();
          message.success(
            result?.data?.message || "Appointment Requested Successfully"
          );
        } else {
          message.error("Appointment Request Failed, Retry");
        }
      })
      .catch((err) => {
        message.error("Appointment Booking Failed, Try Again");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleConsReason = (e) => {
    setConsReason(e.target.value);
    let value = e.target.value;
    if (value && value.length >= 3) {
      const payload = {
        chiefComplaint: value,
      };
      fetchConsReasons(payload);
    }
  };

  const fetchConsReasons = async (filterPayload) => {
    const payload = {
      chiefComplaint: "",
      status: 1,
    };
    let finalPayload;
    if (filterPayload) {
      finalPayload = {
        ...payload,
        ...filterPayload,
      };
    }
    try {
      const response = await PatientService.AllConsReasons(finalPayload);
      setConsultationReasonList(response.data || []);
    } catch (e) {
      console.error(e);
    }
  };
  const [consCode, setConsCode] = useState("");

  const handleConsSelectChange = (reason) => {
    setConsReason(reason?.chiefComplaint ? reason?.chiefComplaint : "");
    setConsCode(reason?.complaintCode ? reason?.complaintCode : "");
    setConsultationReasonList([]);
  };

  const [timeSlot, setTimeSlot] = useState(null);

  const handleStartTimeChange = (time, timeString) => {
    console.log(time, timeString);
    setTimeSlot(timeString);
  };
  const handleConsultationDate = (date, dateString) => {
    const formattedDate = dayjs(date)
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");

    setConsultationDate(formattedDate);
  };

  return (
    <div>
      <div className="flex gap-2 border rounded-lg p-3">
        <div>
          {selectedDoctor.imageName ? (
            <img
              src={process.env.REACT_APP_IMAGE_URL + selectedDoctor?.imageName}
              alt={selectedDoctor.userName}
              className="rounded-full w-10 h-10"
            />
          ) : (
            <img
              src={doctorIcon}
              alt={selectedDoctor.userName}
              className="rounded-full w-10 h-10"
            />
          )}
        </div>
        <div>
          <p className="font-medium text-base">{`${selectedDoctor?.salutation}${selectedDoctor?.firstName} ${selectedDoctor?.lastName}`}</p>
          <p className="text-xs font-medium text-gray-400 mt-1">
            {selectedDoctor?.qualification}
          </p>
          <div className="flex gap-2 mt-1">
            <IoLocationSharp className="mt-1 text-[#001a3fae]" />
            <p>
              {selectedDoctor?.city}, {selectedDoctor?.state}
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-col-2">
        {!patientData?.parentPatientId && (
          <div className="p-3">
            {patientData?.patientId && (
              <div className="w-full">
                <label className="text-base font-semibold text-textGray">
                  Select Patient
                </label>
                <Select
                  className="w-full h-10"
                  value={selectedPatient?.patientId}
                  onChange={handlePatientChange}
                >
                  <Select.Option value={patientData?.patientId}>
                    {patientData?.firstName}
                  </Select.Option>
                  {famList.length !== 0 &&
                    famList.map((fam) => (
                      <Select.Option value={fam.patientId}>
                        {fam.firstName}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            )}
          </div>
        )}
        <div className="text-base font-semibold text-textGray m-2">
          Consultation Type <span className="text-red-500">*</span>
        </div>
        <div className="flex flex-col border-b pb-2 mt-3 ml-4">
          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="consultationType"
              value="video"
              className="accent-[#189FAA]"
              checked={consultationType === "video"}
              onChange={handleChange}
            />
            <span className="text-sm font-bold text-[#189FAA]">
              Video Consultation
            </span>
          </label>

          <label className="flex items-center space-x-2 ">
            <input
              type="radio"
              name="consultationType"
              value="inPerson"
              className="accent-[#189FAA]"
              checked={consultationType === "inPerson"}
              onChange={handleChange}
            />
            <span className="text-sm font-bold text-[#189FAA]">
              In-Person Consultation
            </span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="radio"
              name="consultationType"
              value="homeVisit"
              className="accent-[#189FAA]"
              checked={consultationType === "homeVisit"}
              onChange={handleChange}
            />
            <span className="text-sm font-bold text-[#189FAA]">Home Visit</span>
          </label>
        </div>
        <div className="flex gap-2">
          <div>
            <div className="text-base font-semibold text-textGray m-2">
              Consultation Date <span className="text-red-500">*</span>
            </div>
            <div className="p-3">
              <DatePicker
                type="date"
                format={"DD/MM/YYYY"}
                className="w-[inherit] h-10 rounded-lg outline-none"
                // value={consultationDate}
                onChange={handleConsultationDate}
                placeholder="Select Date"
              />
            </div>
          </div>
          <div>
            <div className="text-base font-semibold text-textGray m-2">
              Consultation Time <span className="text-red-500">*</span>
            </div>
            <div className="p-3">
              <TimePicker
                use12Hours
                format="h:mm a"
                className="w-full mt-1 rounded-lg px-4 py-2"
                onChange={handleStartTimeChange}
                minuteStep={5}
                needConfirm={false}
                allowClear={false}
                inputReadOnly={true}
              />
            </div>
          </div>
        </div>
        <div className="w-full text-primaryColor p-3 relative">
          <label className="text-base font-semibold text-textGray">
            Reason <span className="text-red-500">*</span>
          </label>
          <Input
            value={consReason}
            onChange={handleConsReason}
            className="w-[inherit] h-10 rounded-lg outline-none"
            placeholder="Enter Consultation Reason"
            maxLength={25}
          />
          {consultationReasonList.length > 0 && (
            <ul
              onMouseLeave={() => setConsultationReasonList([])}
              className="absolute w-[100%] mt-1 bg-white border rounded-md shadow-md max-h-20 overflow-y-auto z-20"
            >
              {consultationReasonList.map((reason, index) => (
                <li
                  onClick={() => handleConsSelectChange(reason)}
                  key={index}
                  className="px-2 py-1 text-[13px] font-sans hover:bg-gray-200 cursor-pointer"
                >
                  {reason.chiefComplaint}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <button
        disabled={loading}
        onClick={handleApptSubmit}
        className="m-4 p-2 w-[450px] bg-[#189FAA] text-white font-semibold rounded-lg"
      >
        Request Appointment {loading ? <Spin /> : ""}
      </button>
    </div>
  );
};

export default RequestApptDrawer;
